var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseGraphQlApiServiceFactory } from '@wemogy/reactbase';
import { AuthorizationApiName, AuthorizationApiUri } from '../../../base/Constants';
import Role from '../../models/Role';
var baseModelMin = "\n\tid,\n\tcreatedAt,\n\tupdatedAt\n";
var roleMin = "\n\t" + baseModelMin + ",\n\ttenantId,\n\tname,\n\tlevelRoles\n";
var GraphQlApiServiceFactory = /** @class */ (function (_super) {
    __extends(GraphQlApiServiceFactory, _super);
    function GraphQlApiServiceFactory() {
        return _super.call(this, AuthorizationApiUri, AuthorizationApiName) || this;
    }
    Object.defineProperty(GraphQlApiServiceFactory.prototype, "roleService", {
        get: function () {
            return this.getGraphQlService(Role, "\n\t\t\trole{" + roleMin + "}\n    ", "\n\t\t\troles{" + roleMin + "}\n    ", 'role');
        },
        enumerable: false,
        configurable: true
    });
    return GraphQlApiServiceFactory;
}(BaseGraphQlApiServiceFactory));
export default new GraphQlApiServiceFactory();
//# sourceMappingURL=GraphQlApiServiceFactory.js.map